<template>
  <a-modal
    title="预览"
    :width="1180"
    :visible="visible"
    :maskClosable="true"
    :closable="true"
    :confirmLoading="loading"
    :footer="null"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form>
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              合同信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <span v-if="this.data">{{ this.data['number'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <span v-if="this.data">{{ this.data['project'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="报告类型" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data">{{ this.$Dictionaries.trade_goods_report_types[this.data['report_type']] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="报告内容" :label-col="buttonCol.labelCol" :wrapper-col="buttonCol.wrapperCol">
              <a-row v-if="this.data && data['report_data']">
                <a-col :span="12" v-for="(value, key, index) in data['report_data']" :key="index">
                  {{ key }} : {{ value }}
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="合同附件" :label-col="buttonCol.labelCol" :wrapper-col="buttonCol.wrapperCol">
              <a-table
                bordered
                :data-source="attachmentList"
                :columns="attachmentColumns"
                v-if="this.attachmentList.length > 0"
                :pagination="false"
                key="key">
                <span slot="action" slot-scope="text, record">
                  <template>
                    <a :href="record.url" target="_blank">预览</a>
                  </template>
                </span>
              </a-table>
              <span v-else>无</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import {
  goods_report_attachment_list,
  goods_report_list
} from '@/api/trade_report'
export default {
  name: 'WatchViewForm',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        labelCol: {
          xs: { span: 3 },
          sm: { span: 3 }
        },
        wrapperCol: {
          xs: { span: 21 },
          sm: { span: 21 }
        }
      },
      data: undefined,
      loading: false,
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 300,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      attachmentList: [],
      clientList: []
    }
  },
  mounted () {
    this.loadContract()
    this.loadContractAttachment()
  },
  methods: {
    loadContract () {
      this.loading = true
      goods_report_list({ id: this.model['id'] }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadContractAttachment () {
      goods_report_attachment_list({ report_id: this.model['id'] }).then(res => {
        if (res.code === 1000 && res.data.entries) {
          this.attachmentList = res.data.entries
        }
      })
    }
  }
}
</script>
